'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, Xmark } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Dialog, Modal, ModalOverlay } from 'react-aria-components';
import { Button } from '~/components/Button';
import { useVisualViewportHeight } from '~/hooks/useVisualViewportHeight';
import styles from './CenteredModal.module.css';
import type { CenteredModalProps } from './CenteredModal.types';
const CenteredModal = t0 => {
  const $ = _c(30);
  const {
    ariaLabel,
    children,
    close,
    closeDataTestId: t1,
    closeVariant: t2,
    dataTestId,
    fitContent: t3,
    growToViewport: t4,
    isOpen,
    size: t5
  } = t0;
  const closeDataTestId = t1 === undefined ? "CenteredModalClose" : t1;
  const closeVariant = t2 === undefined ? "close" : t2;
  const fitContent = t3 === undefined ? false : t3;
  const growToViewport = t4 === undefined ? false : t4;
  const size = t5 === undefined ? "medium" : t5;
  const ariaT = useTranslations("aria");
  useVisualViewportHeight(isOpen);
  const isBack = closeVariant === "back";
  const t6 = size === "medium";
  const t7 = size === "large";
  let t8;
  if ($[0] !== fitContent || $[1] !== growToViewport || $[2] !== t6 || $[3] !== t7) {
    t8 = clsx(styles.modal, {
      [styles.modalMedium]: t6,
      [styles.modalLarge]: t7,
      [styles.modalFitContent]: fitContent,
      [styles.modalGrowToViewport]: growToViewport
    });
    $[0] = fitContent;
    $[1] = growToViewport;
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = isBack ? styles.backButton : styles.closeButton;
  let t10;
  if ($[5] !== ariaT || $[6] !== isBack) {
    t10 = isBack ? ariaT("back") : ariaT("close");
    $[5] = ariaT;
    $[6] = isBack;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== isBack) {
    t11 = isBack ? <ArrowLeft decorative={true} size="small" /> : <Xmark decorative={true} size="large" />;
    $[8] = isBack;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== close || $[11] !== closeDataTestId || $[12] !== t10 || $[13] !== t11) {
    t12 = <Button variant="icon" ariaLabel={t10} onPress={close} dataTestId={closeDataTestId}>{t11}</Button>;
    $[10] = close;
    $[11] = closeDataTestId;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12 || $[16] !== t9) {
    t13 = <span className={t9}>{t12}</span>;
    $[15] = t12;
    $[16] = t9;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== ariaLabel || $[19] !== children || $[20] !== dataTestId || $[21] !== t13) {
    t14 = <Dialog className={styles.dialog} aria-label={ariaLabel} data-test-id={dataTestId}>{t13}{children}</Dialog>;
    $[18] = ariaLabel;
    $[19] = children;
    $[20] = dataTestId;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14 || $[24] !== t8) {
    t15 = <Modal className={t8}>{t14}</Modal>;
    $[23] = t14;
    $[24] = t8;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== close || $[27] !== isOpen || $[28] !== t15) {
    t16 = <ModalOverlay className={styles.overlay} isDismissable={true} isOpen={isOpen} onOpenChange={close}>{t15}</ModalOverlay>;
    $[26] = close;
    $[27] = isOpen;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};
export { CenteredModal };